import { SequenceManagerAction } from "./SequenceManagerAction";

const CurrentOperatorAction = {
    SELECT_OPERATOR: "SELECT_OPERATOR",
}

const chooseOperator = (selection: any, offerContainerId: any) => {
    return function (dispatch: any) {
        dispatch({ type: CurrentOperatorAction.SELECT_OPERATOR, payload: { selection: selection, offerContainerId: offerContainerId } });
        dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['CurrentOperator'] });
    };
};

export { CurrentOperatorAction, chooseOperator };